import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@material-ui/core/CssBaseline';

import { loadState, saveState } from './store/sessionStorage';

import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { Provider } from "react-redux";

import reducer from "./redux/reducer";

import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

const persistedState = loadState();
const store = createStore(reducer, persistedState, applyMiddleware(thunk));

store.subscribe(() => {
  saveState(store.getState());
});

// const darkTheme = createTheme({
//   palette: {
//     mode: 'dark', //default theme
//     text: {
//       primary: 'red'
//     },
//     background: {
//       default: '#90caf9',
//     },
//     primary: {
//       main: '#90caf9',
//       contrastText: '#000000'
//     },
//     secondary: {
//       main: '#f48fb1',
//     },
//     link: {
//       main: '#135383',
//     }
//   },
// });

const theme = createTheme({
  palette: {
    primary: {
      main: '#0b314E',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#731DD8',
    },
    link: {
      main: '#135383',
    }
  },
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
